import React, {useEffect} from 'react';
import '../../App.css';
import Footer from '../Footer';
import HomeGallery from '../HomeGallery';


function PortfolioTravel() {
    useEffect(() => {
            const timer = setTimeout(() => {
                window.scrollTo({ top: window.innerHeight * 0.75, behavior: 'smooth' });
                }, 50);
    
            return () => clearTimeout(timer);
    }, []);
        
    return (
    <>
        <h1 className='portfolio-hero'>Portfolio</h1>

        <h1 className='text'>Travel</h1>

        <HomeGallery images={['/images/img-travel-8.jpg','/images/img-travel-9.jpg','/images/img-travel-11.jpg','/images/img-travel-12.jpg','/images/img-travel-1.jpg','/images/img-travel-4.jpg','/images/img-travel-3.jpg','/images/img-travel-2.jpg','/images/img-travel-5.jpg','/images/img-travel-6.jpg','/images/img-travel-7.jpg','/images/img-travel-10.jpg']} />

        <Footer />
    </>
  )
}

export default PortfolioTravel
